import { types } from './types';
import { IEmailLogsResponse, IEmailLogStats } from './types';

export interface IEmailLogsInitialState {
    emailLogs: IEmailLogsResponse | null;
    fetchingEmailLogs: boolean;
    emailLogsError: null | any;
    emailLogStats: IEmailLogStats | null;
    fetchingEmailLogStats: boolean;
    emailLogStatsError: null | any;
}

const initialState: IEmailLogsInitialState = {
    emailLogs: null,
    fetchingEmailLogs: false,
    emailLogsError: null,
    emailLogStats: null,
    fetchingEmailLogStats: false,
    emailLogStatsError: null,
};

export const EmailLogsReducer = (state = initialState, action: any): IEmailLogsInitialState => {
    switch (action.type) {
        case types.FETCH_EMAIL_LOGS:
            return {
                ...state,
                fetchingEmailLogs: true,
                emailLogsError: null,
            };
        case types.FETCH_EMAIL_LOGS_SUCCESS:
            return {
                ...state,
                fetchingEmailLogs: false,
                emailLogs: action.payload,
                emailLogsError: null,
            };
        case types.FETCH_EMAIL_LOGS_FAIL:
            return {
                ...state,
                fetchingEmailLogs: false,
                emailLogsError: action.payload,
            };
        case types.FETCH_EMAIL_LOG_STATS:
            return {
                ...state,
                fetchingEmailLogStats: true,
                emailLogStatsError: null,
            };
        case types.FETCH_EMAIL_LOG_STATS_SUCCESS:
            return {
                ...state,
                fetchingEmailLogStats: false,
                emailLogStats: action.payload,
                emailLogStatsError: null,
            };
        case types.FETCH_EMAIL_LOG_STATS_FAIL:
            return {
                ...state,
                fetchingEmailLogStats: false,
                emailLogStatsError: action.payload,
            };
        default:
            return state;
    }
};
